export class LoginResult {
    constructor(arg) {
        Object.assign(this, arg);
    }
}
